<script setup>
import { computed } from "vue";
import DropZone from "./dropzone/DropZone.vue";
import { ArgonLoadingButton } from "@/components";
import FileView from "./dropzone/FileView.vue";
import { dropzoneStore } from "./dropzone/dropzoneStore";
//import Choices from "choices.js";
import ArgonSelect from "./ArgonSelect.vue"
import ArgonSnackbar from "@/components/ArgonSnackbar.vue";
import ModalBase from "./modal/ModalBase.vue";
import AlertMessage from "@/components/AlertMessage.vue";
import ImportResultSummary from "./ImportResultSummary.vue";
import LinkButton from "@/components/LinkButton.vue";
import { errorUtils } from "@/utils";
import { onMounted, watch, ref } from "vue";
const dropStore = dropzoneStore();

function onInputChange(e) {
  dropStore.addFiles(e.target.files);
  e.target.value = null; // reset so that selecting the same file again will still cause it to fire this change
}
const props = defineProps({
  title: {
    type: String,
    default: "Importar Fichero",
  },
  alertMsg: {
    type: String,
    default: "",
  },
  options: {
    type: Array,
    default() {
      return [];
    },
  },
  url: {
    type: String,
    default: "/",
  },
  templateLinkText: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["download-template"]);

var fileType = ref("");

onMounted(() => {
  dropStore.clearFiles();
  var selected = props.options.find((option) => option.selected);
  if (selected) {
    fileType.value = selected.value;
  }
});
function resetModalState() {
  dropStore.clearFiles();
  let formData =document.getElementById("formData");
  const invalidElements = formData?.querySelectorAll(".is-invalid");
  invalidElements.forEach((element) => {
    element.classList.remove("is-invalid");
  });
}
function validateFile() {
  return dropStore.files.length > 0;
}

function removeFile(file) {
  dropStore.removeFile(file);
}

async function upload() {
  let message = "";
  if(!validateFile()){
    message = `${message}<li>Debe seleccionar al menos un fichero</li>`;
  }
  if (message != "") {
    if (!validateFile()) {
      let idDropZone = document.getElementById("idDropZone");
      if (idDropZone) {
        if (!idDropZone.classList.contains("is-invalid")) {
          idDropZone.classList.add("is-invalid");
        }
      }
    }
    snackbar.value = {
      title: "Error",
      message: message,
      type: "danger",
      color: "white",
    };
    return;
  }
  const contract = { sub_type: fileType.value };
  dropStore.uploadFiles(props.url, contract);
}
function clearModal() {
  resetModalState();
}
function onClick() {
  let idDropZone = document.getElementById("idDropZone");
  if (idDropZone) {
    if (idDropZone.classList.contains("is-invalid")) {
      idDropZone.classList.remove("is-invalid");
    }
  }
}

watch(
  () => dropStore.uploadStatus,
  (newSelection) => {
    if (newSelection == "ERROR") {
      snackbar.value = {
        title: "Error",
        message: errorUtils.getErrorMessageHtml(dropStore.error),
        type: "danger",
        color: "white",
      };
    }
  }
);
const disableButton = computed({
  get() {
    return dropStore.disableButton;
  },
});
const hasImportResult = computed(() => dropStore.importResult !== null);
const snackbar = ref(null);
const closeSnackbar = () => {
  snackbar.value = null;
};
</script>

<template>
  <modal-base
    ref="importModal"
    width="40rem"
    min-height="28rem"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    @hide="clearModal()"
  >
    <template #header>
      <h6 id="ModalLabel" class="modal-title">
        {{ title }}
      </h6>
    </template>
    <template #body>
      <form
        id="formData"
        class="form-control border-0"
        :class="{ 'form-control--result': hasImportResult }"
      >
        <alert-message
          v-if="(alertMsg || templateLinkText) && !hasImportResult"
          title="Aviso"
          type="info"
          class="mb-3"
        >
          <span v-if="alertMsg" v-html="alertMsg"></span>
          <div v-if="templateLinkText" class="mt-1 text-center">
            <link-button
              :label="templateLinkText"
              icon="fa-download"
              @click="emit('download-template')"
            />
          </div>
        </alert-message>
        <import-result-summary
          v-if="hasImportResult"
          :import-result="dropStore.importResult"
        />
        <div v-if="!hasImportResult && options.length > 0">
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-2">
              <label for="format" class="col-form-label required">Formato</label>
            </div>
            <div class="col-12 col-md-10">
              <argon-select
                id="file-format"
                v-model="fileType" name="file-format"
                :options="props.options"
                placeholder="Formato">
              </argon-select>
            </div>
          </div>
        </div>

        <DropZone
          v-if="!hasImportResult"
          id="idDropZone"
          v-slot="{ dropZoneActive }"
          class="drop-area import-modal-dropzone"
          :class="{ 'import-modal-dropzone--active': dropZoneActive }"
          @click="onClick"
          @files-dropped="dropStore.addFiles"
        >
          <label for="file-input" class="import-modal-dropzone__label">
            <i class="fa fa-cloud-upload import-modal-dropzone__icon"></i>
            <span v-if="dropZoneActive" class="import-modal-dropzone__text">
              Suelta aquí tu archivo
            </span>
            <span v-else class="import-modal-dropzone__text">
              Arrastra tu archivo o <span class="import-modal-dropzone__link">haz clic para seleccionarlo</span>
            </span>
          </label>
          <input id="file-input" type="file" @change="onInputChange" />
        </DropZone>

        <file-view
          v-if="!hasImportResult"
          :files="dropStore.files"
          @remove="removeFile"
        ></file-view>
      </form>
    </template>
    <template #footer>
      <argon-loading-button
        v-if="!hasImportResult"
        class="btn bg-gradient-primary btn-xs"
        color="primary"
        variant="gradient"
        :label="disableButton ? 'Importando...' : 'Importar'"
        :loading="disableButton"
        :disable-button="disableButton"
        @click="upload"
      >
      </argon-loading-button>
    </template>
    <div class="position-fixed top-0 end-0 z-index-2 p-3">
      <argon-snackbar
        v-if="snackbar"
        :title="snackbar.title"
        :description="snackbar.message"
        :icon="{ component: 'ni ni-notification-70', color: snackbar.type }"
        :color="snackbar.color"
        :close-handler="closeSnackbar"
      />
    </div>
  </modal-base>
</template>

<style scoped>
.form-control--result {
  padding-left: 4px;
  padding-right: 4px;
}

.import-modal-dropzone {
  border: 2px dashed rgba(15, 23, 42, 0.15);
  border-radius: 10px;
  background: #f8fafc;
  padding: 0;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
  margin-top: 12px;
}

.import-modal-dropzone:hover,
.import-modal-dropzone--active {
  border-color: #051E46;
  background: #f0f4ff;
}

.import-modal-dropzone__label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 28px 20px;
  width: 100%;
  text-align: center;
}

.import-modal-dropzone__icon {
  font-size: 2rem;
  color: #8392ab;
  transition: color 0.2s ease;
}

.import-modal-dropzone:hover .import-modal-dropzone__icon,
.import-modal-dropzone--active .import-modal-dropzone__icon {
  color: #051E46;
}

.import-modal-dropzone__text {
  font-size: 0.82rem;
  color: #8392ab;
  line-height: 1.4;
}

.import-modal-dropzone__link {
  color: #051E46;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>


